import checkIsPeerIdRemotePeerId from '../../../../utils/checkIsPeerIdRemotePeerId';
import mediaTypeAdapter from '../../../../utils/mediaTypeAdapter';
import userStoppedStreamEventAdapter from '../adapters/userStoppedStreamEventAdapter';
import { isStopEventActual, markProducerStopped } from './streamLifecycleGuard';

const CONSUME_QUEUE_KEY = '__global_consume_queue__';

function userStoppedStream(action, payload) {
  let adaptedPayload = { ...payload };

  if (!adaptedPayload.adapted) {
    adaptedPayload = userStoppedStreamEventAdapter(payload);
  }

  const { peerId, producer } = adaptedPayload;

  if (!this.isReadyToHandleEvents) {
    const event = {
      eventName: action,
      pairID: producer?.streamType,
      eventData: { action, payload: adaptedPayload },
      peerID: peerId,
    };

    this.socket.rawEvents.push(event);
    return;
  }

  const isRemotePeerId = checkIsPeerIdRemotePeerId(this.peerInfo, peerId);

  if (!isRemotePeerId) {
    return;
  }

  const isTeacher = this.teacherPeerId === peerId;
  const { producerId, streamType } = producer;
  const mediaType = mediaTypeAdapter(streamType);

  markProducerStopped(peerId, mediaType, producerId);

  const isConsumeQueueExist = this.queue.tasks.has(CONSUME_QUEUE_KEY);

  this.queue.pushTask(CONSUME_QUEUE_KEY, async () => {
    if (!isStopEventActual(peerId, mediaType, producerId)) {
      console.warn('userStoppedStream skipped: stale stop event', {
        peerId,
        producerId,
        mediaType,
        isTeacher,
      });

      this.queue.resumeTaskExecuting(CONSUME_QUEUE_KEY);
      return;
    }

    try {
      await this.mediasoup.closeConsumer(
        this.roomInfo.roomId,
        peerId,
        producerId,
        mediaType,
        isTeacher,
      );
    } catch (error) {
      console.error('userStoppedStream closeConsumer failed', {
        peerId,
        producerId,
        mediaType,
        isTeacher,
        error,
      });
    } finally {
      this.queue.resumeTaskExecuting(CONSUME_QUEUE_KEY);
    }
  });

  if (!isConsumeQueueExist) {
    this.queue.startTask(CONSUME_QUEUE_KEY);
  }
}

export default userStoppedStream;
